<template>
    <div>
        <div data-role="hot-pic" class="clearfix bord hot-atlas" id="topScrollPic">
            <div class="titleR">
                <span class="tt">热门精选</span>
            </div>
            <div id="focus" class="focus">
                <div class="scroll swiper">
                    <div class="widget-swiper">
                        <div class="scroll">
                            <div 
                                class="con" 
                                data-role="item-wrapper" 
                                ref="itemWrapper" 
                                data-spm="fspic">
                                <div
                                    class="pic img-do"
                                    v-for="(item, index) in swiperData"
                                    :key="index"
                                    data-spm-type="resource"
                                >
                                    <a
                                        :href="item.path"
                                        target="_blank"
                                        data-spm-type="content"
                                    >
                                        <img 
                                            :src="preloadUrl"
                                            data-strict="true"
                                            alt=""
                                            :data-src="item.focusImg"
                                        />
                                        <i
                                            class="icon icon-video"
                                            v-if="item.hasVideo"
                                        ></i>
                                    </a>
                                    <span class="linear-box widget-txt">
                                        <em class="linear-bg"></em>
                                        <a :href="item.path" target="_blank">
                                            {{ item.title }}
                                        </a>
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div class="bullets">
                            <span
                                v-for="(i, index) in swiperData"
                                :key="index"
                                :class="index == 0 ? 'active' : ''"
                                :data-id="index"
                                @click="goPage(index)"
                                ><a></a>{{index}}
                            </span>
                        </div>
                        <div class="btns">
                            <a class="btnl" href="javascript:void(0)" @click="goPrev"></a>
                            <a class="btnr" href="javascript:void(0)" @click="goNext"></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 热门图集下方4小图 -->
        <div data-role="four-pic" class="clearfix hot-atlas">
            <div class="pic-group clearfix" data-spm="pic-group" id="bottomPicList">
                <ul>
                    <li
                        v-for="(item, index) in bottomPic"
                        :key="index"
                        style="width: 145px; height:132px;float:left;margin-bottom:10px;padding:0;"
                        :class="picGroupItemStyle(index)"
                    >
                        <a :href="item.url" target="_blank" :data-spm-content="dataSpmCnt(item)">
                            <img :data-src="item.focus" alt="" style="width: 100%;height: 87px;margin-bottom:5px;" :src="preloadUrl">
                            <span class="txt" style="width: 100%;">{{ item.title }}</span>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
import Str from "@/utils/string"
import { setPicSize } from "../../utils/pic-util.js"
import { getOdinResourceIdMap } from '@/config/odinResourceIds'
import { getOdinData,formatOdinData } from "@/request/odinRequest"

export default {
    name: 'HotGallery',
    computed: {
        picGroupItemStyle() {
            return (index) => {
                return index % 2 == 1 ? 'new-end' : ''
            }
        },
        dataSpmCnt() {
            return (item) => {
                return item.adInfo ?
                    item.resourceType + '|' + item.authorId + '|' + item.id + '|' + item.pcm + '|' + item.type + '|' + item?.adInfo
                    : item.resourceType + '|' + item.authorId + '|' + item.id + '|' + item.pcm + '|' + item.type + '|'
            }
        }
    },
    data() {
        return {
            swiperData: [],
            topPic: [], // 头部数据
            curPage: 1, // 当前页数
            totalPage: 3,
            timer: null,
            interval: null,
            duration: 5000,
            type: 0,
            list: [],
            bottomPic: [],
            preloadUrl: "//statics.itc.cn/web/static/images/pic/preload.png",
            scanImgFunc: null,
        }
    },
    mounted() {
        this.fetchData()
        this.initEvent()
    },
    methods: {
        initEvent(){
            window.addEventListener('mouseenter', this.freeze)
            window.addEventListener('mouseleave', this.restart)
            const itemWrapper = this.$refs.itemWrapper
            this.scanImgFunc = () => {
                window.LazyLoadIns?.scanImg()
            }
            itemWrapper.addEventListener('transitionend', this.scanImgFunc)
        },
        async fetchData() {
            const spmObj = window?.sohuSpm?.getCodes()
            const senceKey = 'hotGallery'
            const idsMap = getOdinResourceIdMap(senceKey)
            const param = {
                tplCompKey: senceKey,
                adInfo: idsMap?.adInfo,
                spmCCode: idsMap?.spmCCode,
                resourceId: idsMap?.resourceId,
                content: {
                    page: 1,
                    size: 9,
                    productId: idsMap?.productId,
                    productType: idsMap?.productType,
                    spm: `${spmObj?.a}.${spmObj?.b}.${idsMap?.spmCCode}`
                },
                context:{
                    mkey: "channelId_" + window.pcArticleInfo?.channel_id + "--mpid_" + window.pcArticleInfo?.news_id
                }
            }
            try {
                this.isLoading = true
                let res = await getOdinData(param)
                if(res?.list?.length) {
                    this.list = formatOdinData(res)
                    this.renderTopPic()
                    this.start()
                    this.getBottomPic()
                } else {
                }
                this.isLoading = false
            } catch(error) {
                console.log('热门精选请求error',error)
                this.isLoading = false
            }
        },
        renderTopPic() {
            if(this.list && this.list.length > 0) {
                this.topPic = this.list.slice(0, 3)
                this.topPic.forEach((item, index) => {
                    var cover = item.images && item.images[0]
                    const ratio = 2
                    this.swiperData.push({
                        focusImg: setPicSize(cover, 300*ratio, 200*ratio, 'c_lfill',70) || '',
                        path: item.url,
                        title: Str.subString(item.title, 35)
                    })
                })
            }
            this.$nextTick(() => {
                window?.sohuSpm?.domDidChange({target: 'fspic'})
            })
        },
        setPage(page, speed = '0.5s') {
            this.curPage = page;
            const itemWrapper = this.$refs.itemWrapper;
            const sliderEls = itemWrapper && itemWrapper.children;
            this.translateX = 0 - sliderEls[0]?.offsetWidth * (page - 1);
            if (this.isSupportTransform()) {
                itemWrapper.style.transition = speed;
                itemWrapper.style.transform = `translate3d(${this.translateX}px, 0px, 0)`;
                this.setPageNation(this.curPage);
                this.restart()
            } else {
                itemWrapper.style.left = `${this.translateX}px`;
                itemWrapper.addEventListener('transitionend', () => {
                    if (this.curPage < 0 || this.curPage > this.totalPage - 1) {
                        this.curPage = this.curPage < 0 ? this.totalPage - 1 : 0;
                        this.translateX = this.curPage < 0
                        ? 0 - sliderEls[0].clientWidth * this.totalPage
                        : 0 - sliderEls[0].clientWidth;
                        itemWrapper.style.left = `${this.translateX}px`;
                    }
                    this.setPageNation(this.curPage);
                    this.restart()
                });
            }
            window?.LazyLoadIns?.scanImg()
        },
        goPrev(ev) {
            this.curPage--;
            if (this.curPage < 1) {
                this.setPage(this.totalPage, '0s');
            } else {
                this.setPage(this.curPage);
            }
            ev && this.restart()
        },
        goNext(ev) {
            this.curPage++
            if (this.curPage > this.totalPage) {
                this.setPage(1, '0s');
            } else {
                this.setPage(this.curPage);
            }
            ev && this.restart()
        },
        goPage(index) {
            this.restart()
            this.setPage(index + 1)
        },
        restart(){
            clearInterval(this.interval);
            clearTimeout(this.timer);
            this.timer = setTimeout( ()=>{
                this.start();
            }, 60000);
        },
        setPageNation(page) { // 设置当前活跃page
            const bulletSpans = document.querySelectorAll('.bullets span')
            console.log(bulletSpans, 'span', page);
            bulletSpans.forEach(span => {
                span.classList.length && span.classList.remove('active')
            })
            bulletSpans && bulletSpans.length >= page && bulletSpans[page - 1].classList.add('active')
        },
        isSupportTransform() {
            const element = document.createElement('div');
            return "transform" in element.style;
        },
        start() {
            this.interval = setInterval(this.goNext, this.duration)
        },
        freeze(e) {
            clearInterval(this.interval);
            this.interval = null;
        },
        getBottomPic() {
            if(this.list && this.list.length > 3) {
                this.bottomPic = this.list.slice(3, 7)
                this.bottomPic.forEach((o, index) => {
                    var cover = o.images?.[0]
                    const ratio = 2
                    o.focus = setPicSize(cover, 145*ratio, 87*ratio, 'c_lfill',70)  || '';
                    o.title = Str.subString(o.title, 19)
                })
                setTimeout(() => {
                    window?.LazyLoadIns?.scanImg()
                    window && window.sohuSpm && window.sohuSpm.domDidChange({target: 'pic-group'});
                },200)
            }
        }
    }
}
</script>
<style>
.titleR{height:25px;padding:16px 20px 8px;color:#191919;line-height:25px;text-align:right;position:relative;}
.titleR .tt{font-size:20px;float:left;font-weight:bold;}
</style>
<style lang="less" scoped>
 .hot-atlas {
    background: #ffffff;
    padding-bottom: 10px;
    cursor: pointer;
        .focus{
            width:300px;
            height:200px;
            position: relative;
            overflow: hidden;
            margin:8px auto 0;
            .scroll{
                width:100%;
                height:100%;
                position:relative;
                overflow: hidden;
            }
            .widget-swiper{
                height: 200px;
                border-top: 1px solid rgba(0, 0, 0, 0.05);
                border-bottom: 1px solid rgba(0, 0, 0, 0.05);
                border-left: 1px solid rgba(0, 0, 0, 0.05);
                border-right: 1px solid rgba(0, 0, 0, 0.05);
            }
            .con{
                float:left;
                left:0;
                position:absolute;
                top:0;
                transition:all 0.5s ease 0s;
                width:9999px;
                .pic{
                    float:left;
                    height:200px;
                    position:relative;
                    width:300px;
                    overflow: hidden;
                    img{
                        height:100%;
                        display: block;
                    }
                    .icon-video {
                        position: absolute;
                        left: 50%;
                        top: 50%;
                        width: 40px;
                        height: 40px;
                        margin: -20px 0 0 -20px;
                        background: url(../../images/playBig_icon.png) 0 0 no-repeat;
                    }
                    .linear-box{
                        height: 100px;
                        position:absolute;
                        bottom:0;
                        left:0;
                        display:block;
                        width:100%;
                        display:block;
                        background:#000;
                        background: linear-gradient(to bottom, transparent 0%, rgba(0, 0, 0, 0.9) 100%);
                        a {
                            display: -webkit-box;
                            position:absolute;
                            left:12px;
                            bottom:6px;
                            font-size:16px;
                            line-height:20px;
                            max-height:40px;
                            color:#fff;
                            width:280px;
                            overflow:hidden;
                            transition: all 0.2s ease-in-out;
                            bottom:20px;
                            word-break: break-all;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            -webkit-line-clamp: 2;
                            -webkit-box-orient: vertical;
                        }
                    }
                }
            }
            .btns{
                width:100%;
                left:0;
                pointer-events:none;
                top:85px;
                display: none;
                height:25px;
                a{
                    background:url(../../images/focus_btn01.png) repeat 0 0;
                    left:10px;
                    pointer-events:all;
                    top:0;
                    width:25px;
                    height: 25px;
                    position: absolute;
                }
                .btnr{
                    background-position:0 -30px;
                    left:auto;
                    right:10px;
                }
            }
            .bullets{
                bottom:9px;
                height:2px;
                position:absolute;
                left:12px;
                //width:100%;
                text-align:center;
                span{
                    display:inline-block;
                    vertical-align:top;
                    cursor:pointer;
                    width:6px;
                    height:2px;
                    margin:0;
                    overflow:hidden;
                    transition: all 0.2s ease-in-out;
                    a{
                        display:inline-block;
                        vertical-align:top;
                        background:#ccc;
                        border-radius:3px;
                        font-size:0;
                        height:100%;
                        width:100%;
                    }
                }
                .active{
                    width:12px;
                    a{
                        background: #ffffff;
                    }
                }
            }
            &:hover{
                .btns{
                    display: block;
                }
            }
        }

        .pic-group{
            margin: 0 auto;
            width:300px;
            li{
                position: relative;
                width:300px;
                //height:70px;
                margin-right:10px;
                //float:left;
                overflow: hidden;
                //margin-bottom: 16px;
                padding: 8px 0;
                img{
                    height:60px;
                    width: 90px;
                    display: block;
                    float: left;
                    margin-right: 10px;
                    border-top: 1px solid rgba(0, 0, 0, 0.05);
                    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
                    border-left: 1px solid rgba(0, 0, 0, 0.05);
                    border-right: 1px solid rgba(0, 0, 0, 0.05);
                }
                .txt{
                    margin-top: 5px;
                    display:block;
                    display: -webkit-box;
                    width: 197px;
                    height: 36px;
                    line-height:18px;
                    font-size: 14px;
                    overflow: hidden;
                    word-break: break-all;
                    text-overflow: ellipsis;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                }
                .icon-video {
                    position: absolute;
                    left: 10px;
                    top: 55px;
                    width: 26px;
                    height: 26px;
                    background: url(../../images/playSmall_icon.png) 0 0 no-repeat;
                }
            }
            .end{
                margin-right:10px;
                padding: 8px 0;
            }
            .new-end{
                margin-right:0px !important;
                margin-bottom: 10px !important;
            }
        }
 }
</style>